import { category_actions } from "../actions/actionTypes";

const initialState = {
  categories: [],
  error: null,
  isCatLoading: false, // 🔥 New flag
};

export const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    // Loading started
    case category_actions.CAT_LOADING:
      return {
        ...state,
        isCatLoading: true,
      };

    // On success
    case category_actions.CREATE_CATEGORY:
    case category_actions.GET_CATEGORIES:
    case category_actions.UPDATE_CATEGORY:
    case category_actions.DELETE_CATEGORY:
      return {
        ...state,
        isCatLoading: false,
        categories: (() => {
          switch (action.type) {
            case category_actions.CREATE_CATEGORY:
              return [...state.categories, action.payload];
            case category_actions.GET_CATEGORIES:
              return action.payload;
            case category_actions.UPDATE_CATEGORY:
              return state.categories.map((cat) =>
                cat.id === action.payload.id ? action.payload : cat
              );
            case category_actions.DELETE_CATEGORY:
              return state.categories.filter((cat) => cat.id !== action.payload);
            default:
              return state.categories;
          }
        })(),
      };

    // On error
    case category_actions.ERR_CATEGORY:
      return {
        ...state,
        isCatLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
